import { Dispatch } from 'redux';
import { requestInFlight, requestSuccess, requestError } from '../../entity';
import { getApplicationResources } from 'api';
import { setAppId } from '../actions';

export const fetchCharacters = (appId: string) => async (dispatch: Dispatch) => {
  dispatch(requestInFlight());
  try {
    const { data: characters } = await getApplicationResources(appId);
    dispatch(setAppId(appId));

    // if (appId === 'lnf') {
    //   const characterslnf = characters;
    //   dispatch(requestSuccess({ characterslnf }));
    // } else if (appId === 'woodPieces') {
    //   const characterswoodPieces = characters;
    //   dispatch(requestSuccess({ characterswoodPieces }));
    // } else if (appId === 'wdt') {
    //   const characterswdt = characters;
    //   dispatch(requestSuccess({ characterswdt }));
    // }

    dispatch(requestSuccess({ [`characters${appId}`]: characters }));
  } catch (error) {
    dispatch(requestError(error));
  }
};
